import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "py-10" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<h1 class=\"anchor fw-bolder mb-5\" id=\"line-separator\"><a href=\"#line-separator\"></a> Line Separator </h1><div class=\"py-5\"> Add <code>.breadcrumb-line</code> to enable line separator style for a breadcrumb. </div><div class=\"py-5\"><div class=\"rounded border p-10\"><ol class=\"breadcrumb breadcrumb-line text-muted fs-5 fw-bold\"><li class=\"breadcrumb-item pe-3\"><a href=\"#\" class=\"pe-3\">Home</a></li><li class=\"breadcrumb-item pe-3\"><a href=\"#\" class=\"pe-3\">Library</a></li><li class=\"breadcrumb-item px-3 active text-muted\">Active</li></ol></div></div>", 3)
const _hoisted_5 = { class: "py-5" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString(`
        <ol class="breadcrumb breadcrumb-line text-muted fs-5 fw-bold">
          <li class="breadcrumb-item pe-3">
            <a href="#" class="pe-3">Home</a>
          </li>
          <li class="breadcrumb-item pe-3">
            <a href="#" class="pe-3">Library</a>
          </li>
          <li class="breadcrumb-item px-3 active text-muted">Active</li>
        </ol>
        `))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_5, [
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      })
    ])
  ]))
}